import { makeObservable, observable, action, computed } from 'mobx'
import type Checklist from './Checklist'
import { v4 as uuidv4 } from 'uuid'
import Store from './Store'

export default class ChecklistSection {
  id: string
  name: string = ''
  position: number = 0
  checklist: Checklist
  store: Store

  deleted: boolean = false
  saving: boolean = false
  lastError?: string

  constructor(store: Store, checklist: Checklist, name: string) {
    makeObservable(this, {
      id: false,
      name: observable,
      position: observable,
      items: computed,
      fromProvider: action,
      setName: action,
      setLastError: action,
      setDeleted: action,
      setSaving: action,
    })
    this.store = store
    this.checklist = checklist
    this.id = uuidv4()
    this.name = name
  }

  get items() {
    return this.checklist.items.filter((item) => item.sectionId === this.id)
  }

  // addItem = (name: string) => {
  //   const item = this.checklist.buildItem(name)
  //   item.sectionId = this.id
  //   item.position = this.items.length
  //   item.handleCreate()
  // }

  setName = (name: string) => {
    this.name = name
    // this.handleUpdate()
  }

  setDeleted(value: boolean) {
    this.deleted = value
  }

  setSaving(value: boolean) {
    this.saving = value
  }

  setLastError(value: string | undefined) {
    this.lastError = value
  }

  fromProvider(json: string | object) {
    const { id, name, position } =
      typeof json === 'object' ? json : JSON.parse(json)
    if (id) this.id = id
    if (name) this.name = name
    if (position) this.position = position
  }

  // handleCreate = () => {
  //   this.store.provider
  //     .createChecklistSection(this.checklist.id, { name: this.name })
  //     .then((item) => this.fromProvider(item))
  //     .catch((e) => {
  //       this.setLastError("Failed to add item")
  //       throw e
  //     })
  //     .finally(() => {
  //       this.setSaving(false)
  //     })
  // }
}
